import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ServiceCard.css";

interface ServiceCardProps {
  title: string;
  desc: string;
  icon: string;
  color: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  title,
  desc,
  icon,
  color,
}) => {
  return (
    <div className='col-md-4'>
      <div
        className='card h-100 shadow-sm text-center p-4 service-card brand-card'
        style={{ borderTop: `4px solid ${color}` }}
      >
        <div className='icon' style={{ color }}>
          <i className={icon}></i>
        </div>
        <h5 className='mt-3'>{title}</h5>
        <p className='text-muted'>{desc}</p>
      </div>
    </div>
  );
};

export default ServiceCard;
